import { isBareKeyShortcut } from "@/lib/bare-key-shortcut";
import { shortcutKey } from "@/lib/keyboard-shortcuts";

/**
 * BRE-9251: every create dialog opens and submits the same way. `C` presses the
 * page's create button and Mod+Enter presses the open dialog's submit button,
 * so each keeps its own disabled rule, permission gate and submit path.
 */
export const CREATE_SHORTCUT_ATTRIBUTE = "data-create-shortcut";
export const DIALOG_SUBMIT_ATTRIBUTE = "data-dialog-submit";

export function isCreateShortcut(event: KeyboardEvent): boolean {
  return isBareKeyShortcut(event, shortcutKey("create"));
}

/** Mod+Enter, unless something inside already used it (an editor ticking a to-do). */
export function isSubmitShortcut(event: KeyboardEvent): boolean {
  return (
    event.key === "Enter" &&
    (event.metaKey || event.ctrlKey) &&
    !event.altKey &&
    !event.repeat &&
    !event.isComposing &&
    !event.defaultPrevented
  );
}

/** The first element under `root` marked with `attribute` that a click would reach. */
export function findShortcutTarget(root: ParentNode, attribute: string): HTMLElement | null {
  for (const element of Array.from(root.querySelectorAll<HTMLElement>(`[${attribute}]`))) {
    if (element.matches(":disabled, [aria-disabled='true']")) continue;
    if (typeof element.checkVisibility === "function" && !element.checkVisibility()) continue;
    return element;
  }
  return null;
}
